import Swiper from "swiper";
import {  Autoplay, Scrollbar, Navigation, Pagination, FreeMode } from "swiper/modules";

export function initSliderHighlightimages(query = document.querySelectorAll('.sliderHighlightimages')) {
    for (let highlightContainer of query) {
        if (!highlightContainer) return;

        const sliderContainer = document.createElement('div');
        sliderContainer.classList.add('swiper-container');

        const slider = document.createElement('div');
        slider.classList.add('swiper');

// Create wrapper for slides
        const wrapper = document.createElement('div');
        wrapper.classList.add('swiper-wrapper');

// Temporary array to store bannerPoint__content elements
        const bannerContents = [];

// Move slides into the wrapper and add swiper-slide class
        Array.from(highlightContainer.children).forEach(child => {
            if (child.nodeType === 1) {
                const swiperSlide = document.createElement('div');
                swiperSlide.classList.add('swiper-slide');

                // Collect bannerPoint__content elements before appending the child
                const tempContainer = document.createElement('div');
                tempContainer.appendChild(child);

                const contentElements = tempContainer.querySelectorAll('.bannerPoint__content');
                contentElements.forEach(el => {
                    bannerContents.push(el);
                });

                swiperSlide.appendChild(child);
                wrapper.appendChild(swiperSlide);
            }
        });

// Append wrapper to slider
        slider.appendChild(wrapper);
        sliderContainer.appendChild(slider);

// Clear and rebuild the slider content
        highlightContainer.innerHTML = '';

// Add pagination and navigation controls
        const pagination = document.createElement('div');
        pagination.classList.add('swiper-pagination');

        const scrollbar = document.createElement('div');
        scrollbar.classList.add('swiper-scrollbar');

        const nextBtn = document.createElement('div');
        nextBtn.classList.add('swiper-button-next');

        const prevBtn = document.createElement('div');
        prevBtn.classList.add('swiper-button-prev');

// Append everything to the DOM
        sliderContainer.appendChild(prevBtn);
        sliderContainer.appendChild(nextBtn);
        highlightContainer.appendChild(sliderContainer);
        highlightContainer.appendChild(pagination);
        highlightContainer.appendChild(scrollbar);

// Append all bannerPoint__content elements to highlightContainer
        bannerContents.forEach(el => {
            highlightContainer.appendChild(el);
        });


        Swiper.use([Navigation, FreeMode, Pagination, Scrollbar, Autoplay]);

        const swiperInstance = new Swiper(slider, {
            spaceBetween: 0,
            slidesPerView: 0.5,
            scrollbar: {
                enabled: true,
                el: scrollbar
            },
            freeMode: {
                enabled: true,
            },
            navigation: {
                nextEl: nextBtn,
                prevEl: prevBtn
            },
            pagination: {
                el: pagination,
                clickable: true
            },
            speed: 10000,

            autoplay: {
                enabled: true,
                delay: 0,
                disableOnInteraction: true,
                stopOnInteraction: true,
                pauseOnMouseEnter: true,
                pauseOnFocus: true,
            },
            breakpoints: {
                768: {
                    speed: 300,
                    autoplay: false,
                    slidesPerView: 1,
                    freeMode: false
                }
            }
        });
        swiperInstance.autoplay?.stop();

        // 👀 Start autoplay when in viewport
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting && swiperInstance.params.breakpoints[swiperInstance.currentBreakpoint].autoplay) {
                    swiperInstance.autoplay?.start();
                } else {
                    swiperInstance.autoplay?.stop();
                }
            });
        }, { threshold: 0.5 });
        observer.observe(highlightContainer);
    }
}
